// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k9csb","rootNoMargin":"styles_rootNoMargin__3lcSE"};